import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { FormEntriesExportActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function EntriesExport({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as FormEntriesExportActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》数据导出成功</ItemWrapper>
}
